// extracted by mini-css-extract-plugin
export default {"container":"bookbox_container__ZGQjY","links":"bookbox_links__1Oujb","title":"bookbox_title__ey4gX","logo":"bookbox_logo__F6BLF"};